import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropdown-select-modal',
  templateUrl: './dropdown-select-modal.component.html',
  styleUrls: ['./dropdown-select-modal.component.css'],
})
export class DropdownSelectModalComponent implements OnInit {
  @Input() modalTitle: string;
  @Input() dropdownItems: any[];
  @Input() bindValue: string;
  @Input() bindLabel: string;
  @Input() confirmationButtonText = 'Save';
  @Input() cancelButtonText = 'Cancel';
  @Input() onSave: Function;
  @Input() selectedItem: any = null;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  ngOnInit(): void {}

  saveAndCloseModal() {
    if (this.onSave) {
      this.onSave();
    }
    this.ngbActiveModal.close(this.selectedItem);
  }

  closeModal() {
    this.ngbActiveModal.close(undefined);
  }
}
